import { IApplicationState } from '../../types/redux/store';

export const selectIsOpen = (state: IApplicationState) => {
  return state.saveSearch.isOpen;
};
